import {
  Component,
  OnInit,
  AfterContentInit,
  ChangeDetectorRef,
  ElementRef
} from '@angular/core';
import { BadgesControl } from '@tmhcc-ng-lib/framwork/badge';
import { GridOptions } from '@tmhcc-ng-lib/framwork/grid';
import {
  DashboardService,
  BaseSiteCoreAPIMapper,
  GlobalVariablesService,
  StepsService,
  AppDataService,
  StepRequest,
  AgencyLossRunResponse,
  AgencyLossRunRequest,
  BoundPolicyReportRequest,
  DocumentService,
  BoundPolicyReportResponse
} from '@tmhcc-ng-lib/data-service';
import { Accordion } from '@tmhcc-ng-lib/framwork/models';
import { DashboardResponse } from '@tmhcc-ng-lib/data-service';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  HeaderContentService,
  DashboardContentService,
  CommonContentService
} from '@tmhcc-ng-lib/content-service';
import { HeaderContentType } from 'libs/content-service/def/header-content';
import {
  Router,
  Event,
  NavigationStart,
  NavigationEnd,
  ActivatedRoute
} from '@angular/router';
import {
  ProductsNavRoutes,
  SubmissionType,
  ProductType,
  AllowedPLNavRoutes,
  AllowedPRNavRoutes,
  AllowedBRNavRoutes,
  AllowedCENavRoutes,
  AllowedRoutes,
  AllowedEXNavRoutes,
  Status
} from '@tmhcc-ng-lib/models';
import { has } from 'libs/util/has-value';
import { IsTrue } from 'libs/util/binary-util';
import { AccordionService } from '../accordion-menu/accordion.service';
import {
  GLSubmissionRoutes,
  AllowedGLNavRoutes
} from 'libs/models/enums/gl-menus.model';
import { GlobalService } from '@tmhcc-ng-lib/global-services';
import { StepNevigationService } from '../common-liability/nevigation/step-nevigation.service';
import { error } from 'jquery';
import { isNullUndefinedEmptyOrWhiteSpace } from '@tmhcc/util';
import { AlertTosterService } from '@tmhcc/framwork/alert-toster';
import { validateSessionIdType } from '@tmhcc-ng-lib/data-service';
import { OktaLoginService } from '@tmhcc-ng-lib/okta-service';
@Component({
  selector: 'ae-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  badge: BadgesControl;
  dashboardGridList: DashboardResponse;
  dashboardGridList1: DashboardResponse;
  dashboardGridList2: DashboardResponse;
  dashboardGridList3: DashboardResponse;
  dashboardGridList4: DashboardResponse;
  dashboardGridList5: DashboardResponse;
  dashboardGridList6: DashboardResponse;  
  valueSub = new Subscription();
  selectedList: any;
  gridRefresh = false;
  frmGroup: FormGroup;
  show = true;
  actionRequiredCount: number;
  actionRequiredData: any;
  upcomingData: any;
  gridloading = true;
  upcomingBadgeLoading = true;
  actionBadgeLoading = true;
  bountBadgeLoading = true;
  upcomingDataCount: number;
  subjectivityData: any;
  subjectivityCount: number;
  pendingData: any;
  pendingCount: number;
  boundData: any;
  boundCount: number;
  AdvancedSearchData: any;
  dataFoundInGrid:any[] = [];
  allDataFoundInGrid:any[] = [];
  dataUniqueFoundInGrid:any;
  AdvancedSearchCount: number;
  InsuredName: string;
  PolicyIdentifier: string;
  columnSetting: any;
  kpiHeadingFirst: any;
  dashboardDescription: any;
  isShow: boolean = false;
  isShowProductInfo: boolean = false;
  artisanEdgeLabel;
  // showPost: boolean = localStorage.showPost ? true : false;
  showPost: boolean = true;
  dashboardSitecoreSettings2: any;
  welcomeData: any;
  welcomeMessage: any;
  gridId;
  bannerData;
  dashboardSitecoreData;
  productList;  

  constructor(
    private dashboard: DashboardService,
    private loaderService: LoaderService,
    public router: Router,
    private routes: ActivatedRoute,
    private siteCoreDataMapper: BaseSiteCoreAPIMapper,
    private cdr: ChangeDetectorRef,
    private headerContentService: HeaderContentService,
    private customElement: ElementRef,
    private globalVarService: GlobalVariablesService,
    private appDataService: AppDataService,
    private stepNevigationService: StepNevigationService,
    private stepsService: StepsService,
    private documentService: DocumentService,
    private alert: AlertTosterService,
    private oktaLoginService: OktaLoginService,
    private commonContentService: CommonContentService    
  ) {
    this.loaderService.show();
  }

  accordionGridData: Accordion[] = [];
  gridSetting: GridOptions;
  protected data: any;
  dashboardSitecoreSettings: any;
  badges: any;
  selectedSubComp: any;
  headerData: HeaderContentType;  
  isDataAvailable: boolean = false;
  ngOnInit(): void {
    this.commonContentService.setPageTitle();
    let qString = location.href.split('?')[1];
    if (!this.nevigateToPolicyInfo(qString)) {
      this.globalVarService.isSummaryEnable = 'false';
      this.dashboardSitecoreSettings = this.siteCoreDataMapper.fetchGridDataFromMappedSitecoreData(
        this.routes.snapshot.data['dashboard']
      );

      this.welcomeData = this.siteCoreDataMapper.fetchDataFromMappedSitecoreData(
        this.routes.snapshot.data['dashboard']
      );
      this.welcomeMessage = this.siteCoreDataMapper.fetchMessageDataFromMappedSitecoreData(
        this.routes.snapshot.data['dashboard']
      );
      this.bannerData = this.siteCoreDataMapper.fetchBannerDataFromMappedSitecoreData(
        this.routes.snapshot.data['dashboard']
      );
      this.dashboardSitecoreData = this.siteCoreDataMapper.fetchDashboardDataFromMappedSitecoreData(
        this.routes.snapshot.data['dashboard']
      );
      this.headerContentService.data$.subscribe(res => {
        if (res) this.callHeaderData(res);
      });
      this.badges = this.siteCoreDataMapper.fetchBadgeDataFromMappedSitecoreData(
        this.routes.snapshot.data['dashboard']
      );
      this.kpiHeadingFirst = this.badges[0].heading;
      this.data = this.routes.snapshot.data['dashboard']['masterData'];
      this.selectedSubComp = this.globalVarService.agencyId;
      //this.selectedSubComp = '1121314';
      this.initializeAccordian();
      this.getDashboardAdvancedSearch();
      this.getDashboardActionData();
      this.getDashboardUpcomingRenewal();
      this.getDashboardSubjectivityData();
      this.getDashboardPendingData();
      this.getDashboardBoundData();      
      this.loaderService.hide();
      this.globalVarService.resetSteps();
    }
  }

  nevigateToPolicyInfo(qString) {

    if (qString == null || qString.trim().length == 0)
    {
      return false;
    }

    var _policyId = '';
    var _versionNum = '';

    const querystring = new URLSearchParams(qString);

    if (querystring.has('policynum'))
    {
      var policyNum = querystring.get('policynum');
      if (policyNum.trim().length > 0 && policyNum.includes('-'))
      {
        _policyId = policyNum.split('-')[0] || '';
        _versionNum = policyNum.split('-')[1] || '';

        this.globalVarService.resetSteps();
        let payload: StepRequest = {
          policyId: _policyId,
          versionNum: _versionNum
        };
        this.getPolicyInfo(payload);
      }
    }
    return false; // continue to dashboard page
  }

  callHeaderData(data) {
    if (data) {
      this.headerData = data;

      this.productList = this.headerContentService.getProductMenu(
        data.headerDropdown[0].displayItems
      );
      //TODO:  test after login
      this.productList =this.productList.filter(item => {
        return item.Name !== 'Pollution Liability';
      });
      //TODO:  test after login
      this.headerData.headerDropdown[1].displayItems =this.headerData.headerDropdown[1].displayItems.filter(item => {
        return item.keyText !== 'Artisan Pollution Liability';
      });
      this.artisanEdgeLabel = this.headerData.mainLinks[0].heading;
      this.isDataAvailable = true;
    }
  }

  accordianEvent(event) {
    if (has(event, 'targetAction')) {
      this.gridId = event;

      this.accordionGridData.forEach(d => {
        d.accordion.forEach(ele => {
          ele.isToggle = ele.id === event.id ? ele.isToggle : false;
          ele.gridDefination.data = [];
          ele.loading = true;
        });
      });
      this.accordionGridData[0].accordion[0].loading = false;
      this.accordionGridData[0].accordion[0].isServiceError = false;

      setTimeout(() => {
        if (this.gridId) {
          switch (this.gridId.id) {
            case 'collapse-content-1':
              this.badge.badgeConfig.selectedBadge = 1;
              this.accordionGridData[1].accordion[0].gridDefination.data = this.actionRequiredData;
              break;
            case 'collapse-content-2':
              this.badge.badgeConfig.selectedBadge = 2;
              this.accordionGridData[2].accordion[0].gridDefination.data = this.upcomingData;
              break;
            case 'collapse-content-3':
              this.badge.badgeConfig.selectedBadge = 3;
              this.accordionGridData[3].accordion[0].gridDefination.data = this.subjectivityData;
              break;
            case 'collapse-content-4':
              this.badge.badgeConfig.selectedBadge = null;
              this.accordionGridData[4].accordion[0].gridDefination.data = this.pendingData;
              break;
            case 'collapse-content-5':
              this.badge.badgeConfig.selectedBadge = null;
              this.accordionGridData[5].accordion[0].gridDefination.data = this.boundData;
              break;
            case 'collapse-content-0':
              this.badge.badgeConfig.selectedBadge = null;              
              if(this.AdvancedSearchData != null)
                this.accordionGridData[0].accordion[0].gridDefination.data = this.AdvancedSearchData;
              break;
            default:
              this.badge.badgeConfig.selectedBadge = null;
              break;
          }
        }
        this.gridDataRefresh();
      }, 500);
    }
  }
  gridRowEvent(event) {
    if (has(event, 'value.PolicyID') && has(event, 'value.VersionNum')) {
      let payload: StepRequest = {
        policyId: event.value.PolicyID,
        versionNum: event.value.VersionNum
      };
      this.getPolicyInfo(payload);
    } else {
      throw new Error('Could not find Policy Id & Version No.');
    }
  }
  getPolicyInfo(payload: StepRequest) {
    this.loaderService.show();
    this.stepsService.getPolicyDetails(payload).subscribe(res => {
      this.stepNevigationService.stepNevigation(res);
    });
  }

  gridDataRefresh() {
    if (window.innerWidth <= 1200) {
      this.gridRefresh = false;
      setTimeout(() => {
        this.gridRefresh = true;
      }, 0);
    }
  }
  showPostContent(val) {
    if (val === 0) {
      this.showPost = true;
    } else {
      this.showPost = false;
    }
    localStorage.showPost = this.showPost;
  }
  showNewQuote() {
    this.isShow = !this.isShow;

    this.isShowProductInfo = false;
  }
  showProductInfo() {
    this.isShowProductInfo = !this.isShowProductInfo;
    this.isShow = false;
  }
  newQuote(name, policyTypeId, subCompanyCode) {
    this.globalVarService.resetGlobalVariableCache();
    this.appDataService.showSummary.next(false);
    this.globalVarService.policyTypeId = policyTypeId;
    this.globalVarService.subCompanyCode = subCompanyCode;

    this.globalVarService.productName =
      name === ProductType.General || name === ProductType.RemodelingGL
        ? ProductType.General
        : name;

    switch (this.globalVarService.productName) {
      case ProductType.General:
        this.router.navigateByUrl(AllowedGLNavRoutes.Insured);
        break;
      case ProductType.Pollution:
        this.router.navigateByUrl(AllowedPLNavRoutes.Insured);
        break;
      case ProductType.Professional:
        this.router.navigateByUrl(AllowedPRNavRoutes.Insured);
        break;
      case ProductType.Builders:
        this.router.navigateByUrl(AllowedBRNavRoutes.Insured);
        break;
      case ProductType.Excess:
        this.router.navigateByUrl(AllowedEXNavRoutes.Insured);
        break;
      case ProductType.Contractors:
        this.router.navigateByUrl(AllowedCENavRoutes.Insured);
        break;
      //More conditions have to come
      default:
        this.router.navigate([AllowedRoutes.Dashboard]);
    }
  }
  onClickedOutside(e: Event) {
    this.isShowProductInfo = false;
    this.isShow = false;
  }

  initializeAccordian() {
    this.accordionGridData = [];
    this.initializeAdvancedSearchAccordian();
    this.initializeActionAccordian();
    this.initializeUpcomingAccordian();
    this.initializeSubjectivityAccordian();
    this.initializePendingAccordian();
    this.initializeBoundAccordian();    
    this.getBaggageData();
  }
  initializeActionAccordian() {
    const columnSetting = this.dashboardSitecoreSettings.find(
      d => d.gridName == this.dashboardSitecoreData.gridData[0].gridName
    ).data.ColumnDefinition;
    this.accordionGridData.push({
      id: 'accordio-1',
      class: 'accordio-1',
      heading:
        this.dashboardSitecoreData.gridData[0].gridName +
        ' - ' +
        (this.actionRequiredCount || 'Loading...'),
      accordion: [
        {
          id: 'collapse-content-1',
          class: 'Action-Required',
          icon: 'fa fa-plus',
          subHeading:
            this.dashboardSitecoreData.gridData[0].gridName +
            ' - ' +
            (this.actionRequiredCount || 'Loading...'),
          gridDefination: {
            gridOptions: this.dashboardSitecoreSettings.find(
              d => d.gridName == this.dashboardSitecoreData.gridData[0].gridName
            ).data.GirdDefination,
            isCheckbox: false,
            data: this.dashboardGridList?.Policies || [],
            columnDefination: columnSetting
          },
          targetAction: 'reserve',
          isToggle: false
        }
      ]
    });
  }
  initializeUpcomingAccordian() {
    const columnSetting = this.dashboardSitecoreSettings.find(
      d => d.gridName == this.dashboardSitecoreData.gridData[1].gridName
    ).data.ColumnDefinition;

    this.accordionGridData.push({
      id: 'accordio-2',
      class: 'accordio-2',
      heading:
        this.dashboardSitecoreData.gridData[1].gridName +
        ' - ' +
        (this.upcomingDataCount || 'Loading...'),
      accordion: [
        {
          id: 'collapse-content-2',
          class: 'Upcoming-Renewals',
          icon: 'fa fa-plus',
          subHeading:
            this.dashboardSitecoreData.gridData[1].gridName +
            ' - ' +
            (this.upcomingDataCount || 'Loading...'),
          targetAction: 'payment',
          isToggle: false,
          gridDefination: {
            gridOptions: this.dashboardSitecoreSettings.find(
              d => d.gridName == this.dashboardSitecoreData.gridData[1].gridName
            ).data.GirdDefination,
            isCheckbox: false,
            data: this.upcomingData || [],
            columnDefination: columnSetting
          }
        }
      ]
    });
  }
  initializeSubjectivityAccordian() {
    const columnSetting = this.dashboardSitecoreSettings.find(
      d => d.gridName == this.dashboardSitecoreData.gridData[2].gridName
    ).data.ColumnDefinition;
    this.accordionGridData.push({
      id: 'accordio-3',
      class: 'accordio-3',
      heading:
        this.dashboardSitecoreData.gridData[2].gridName +
        ' - ' +
        (this.subjectivityCount || 'Loading...'),
      accordion: [
        {
          id: 'collapse-content-3',
          class: 'Open-Subjectivities',
          icon: 'fa fa-plus',
          subHeading:
            this.dashboardSitecoreData.gridData[2].gridName +
            ' - ' +
            (this.subjectivityCount || 'Loading...'),
          gridDefination: {
            gridOptions: this.dashboardSitecoreSettings.find(
              d => d.gridName == this.dashboardSitecoreData.gridData[2].gridName
            ).data.GirdDefination,
            isCheckbox: false,
            data: this.subjectivityData || [],
            columnDefination: columnSetting
          },
          targetAction: 'reserve',
          isToggle: false
        }
      ]
    });
  }
  initializePendingAccordian() {
    const columnSetting = this.dashboardSitecoreSettings.find(
      d => d.gridName == this.dashboardSitecoreData.gridData[3].gridName
    ).data.ColumnDefinition;

    this.accordionGridData.push({
      id: 'accordio-4',
      class: 'accordio-4',
      heading:
        this.dashboardSitecoreData.gridData[3].gridName +
        ' - ' +
        (this.pendingCount || 'Loading...'),
      accordion: [
        {
          id: 'collapse-content-4',
          class: 'Pending-Transactions',
          icon: 'fa fa-plus',
          subHeading:
            this.dashboardSitecoreData.gridData[3].gridName +
            ' - ' +
            (this.pendingCount || 'Loading...'),
          gridDefination: {
            gridOptions: this.dashboardSitecoreSettings.find(
              d => d.gridName == this.dashboardSitecoreData.gridData[3].gridName
            ).data.GirdDefination,
            isCheckbox: false,
            data: this.pendingData || [],
            columnDefination: columnSetting
          },
          targetAction: 'reserve',
          isToggle: false
        }
      ]
    });
  }
  initializeBoundAccordian() {
    const columnSetting = this.dashboardSitecoreSettings.find(
      d => d.gridName == this.dashboardSitecoreData.gridData[4].gridName
    ).data.ColumnDefinition;
    this.accordionGridData.push({
      id: 'accordio-5',
      class: 'accordio-5',
      heading:
        this.dashboardSitecoreData.gridData[4].gridName +
        ' - ' +
        (this.boundCount || 'Loading...'),
      accordion: [
        {
          id: 'collapse-content-5',
          class: 'Bound-Policies',
          icon: 'fa fa-plus',
          subHeading:
            this.dashboardSitecoreData.gridData[4].gridName +
            ' - ' +
            (this.boundCount || 'Loading...'),
          gridDefination: {
            gridOptions: this.dashboardSitecoreSettings.find(
              d => d.gridName == this.dashboardSitecoreData.gridData[4].gridName
            ).data.GirdDefination,
            isCheckbox: false,
            data: this.boundData || [],
            columnDefination: columnSetting
          },
          targetAction: 'reserve',
          isToggle: false
        }
      ]
    });
  }

  initializeAdvancedSearchAccordian() {
    const columnSetting = this.dashboardSitecoreSettings.find(
      d => d.gridName == this.dashboardSitecoreData.gridData[5].gridName
    ).data.ColumnDefinition;
    this.accordionGridData.push({
      id: 'accordio-0',
      class: 'accordio-0',
      heading:
        this.dashboardSitecoreData.gridData[5].gridName, 
        // +
        // ' - ' +
        // (this.AdvancedSearchCount || 'Loading...'),
      accordion: [
        {
          id: 'collapse-content-0',
          class: 'Advanced-Search',
          icon: 'fa fa-plus',
          subHeading:
            this.dashboardSitecoreData.gridData[5].gridName, 
            // +
            // ' - ' +
            // (this.AdvancedSearchCount || 'Loading...'),
          isAdvSearch:true,
          gridDefination: {
            gridOptions: this.dashboardSitecoreSettings.find(
              d => d.gridName == this.dashboardSitecoreData.gridData[5].gridName
            ).data.GirdDefination,
            isCheckbox: false,
            data: this.AdvancedSearchData || [],
            columnDefination: columnSetting                    
          },
          targetAction: 'reserve',
          isToggle: false,
          loading: false,
          isServiceError:false        
        }
      ]
    });
  }
  getDashboardActionData() {
    this.dashboard.getDashboardActionData(this.selectedSubComp).subscribe(
      data => {
        this.updateAccordianHeader(1, '0');
        this.dashboardGridList = data;
        this.actionRequiredData = this.dashboardGridList.Policies;
        this.actionRequiredCount = this.actionRequiredData.length;

        this.badge.tabs[1].badgeTitle = `${this.actionRequiredCount}`;
        this.badge.tabs[1].isDataLoaded = true;

        this.updateAccordianHeader(1, this.actionRequiredCount);
        //this.accordionGridData[0].accordion[0].gridDefination.data = this.actionRequiredData;
      },
      error => {
        this.updateAccordianHeader(1, 'Failed to load');
        //throw error;
      }
    );
  }
  getDashboardUpcomingRenewal() {
    this.dashboard.getDashboardUpcomingData(this.selectedSubComp).subscribe(
      data => {
        this.updateAccordianHeader(2, '0');
        this.dashboardGridList1 = data;
        this.upcomingData = this.dashboardGridList1.Policies;
        this.upcomingDataCount = this.upcomingData.length;

        this.badge.tabs[0].badgeTitle = `${this.upcomingDataCount}`;
        this.badge.tabs[0].isDataLoaded = true;

        this.updateAccordianHeader(2, this.upcomingDataCount);
        //this.accordionGridData[1].accordion[0].gridDefination.data = this.upcomingData;
      },
      error => {
        this.updateAccordianHeader(2, 'Failed to load');
        //throw error;
      }
    );
  }
  getDashboardSubjectivityData() {
    this.dashboard.getDashboardSubjectivityData(this.selectedSubComp).subscribe(
      data => {
        this.updateAccordianHeader(3, '0');
        this.dashboardGridList2 = data;
        this.subjectivityData = this.dashboardGridList2.Policies;
        this.subjectivityCount = this.subjectivityData.length;

        this.badge.tabs[2].badgeTitle = `${this.subjectivityCount}`;
        this.badge.tabs[2].isDataLoaded = true;

        this.updateAccordianHeader(3, this.subjectivityCount);
        //this.accordionGridData[2].accordion[0].gridDefination.data = this.subjectivityData;
      },
      error => {
        this.updateAccordianHeader(3, 'Failed to load');
        //throw error;
      }
    );
  }

  getDashboardPendingData() {
    this.dashboard.getDashboardPendingData(this.selectedSubComp).subscribe(
      data => {
        this.updateAccordianHeader(4, '0');
        this.dashboardGridList3 = data;
        this.pendingData = this.dashboardGridList3.Policies;
        this.pendingCount = this.pendingData.length;

        this.updateAccordianHeader(4, this.pendingCount);
        //this.accordionGridData[3].accordion[0].gridDefination.data = this.pendingData;
      },
      error => {
        this.updateAccordianHeader(4, 'Failed to load');
        //throw error;
      }
    );
  }

  getDashboardBoundData() {
    this.dashboard.getDashboardBoundData(this.selectedSubComp).subscribe(
      data => {
        this.updateAccordianHeader(5, '0');
        this.dashboardGridList4 = data;
        this.boundData = this.dashboardGridList4.Policies;
        this.boundCount = this.boundData.length;

        this.updateAccordianHeader(5, this.boundCount);
        //this.accordionGridData[4].accordion[0].gridDefination.data = this.boundData;

        this.gridRefresh = true;
        this.loaderService.hide();
        this.gridloading = false;
      },
      error => {
        this.updateAccordianHeader(5, 'Failed to load');
        //throw error;
      }
    );
  }

  getDashboardAdvancedSearch() {
    this.AdvancedSearchData = null;
    this.AdvancedSearchCount = 0;    
  }

  handleData(data: { selectedSearchBy: string, enteredSearchText: string }) {
    this.dataFoundInGrid = [];
    this.allDataFoundInGrid = [];
    this.dataUniqueFoundInGrid = [];  
    this.AdvancedSearchData = []; 
    if(data.selectedSearchBy == "InsuredName"){      
      this.dataFoundInGrid.push(this.actionRequiredData.filter(x => x.Insured.toLowerCase().includes(data.enteredSearchText.toLowerCase())));            
      this.dataFoundInGrid.push(this.upcomingData.filter(x => x.Insured.toLowerCase().includes(data.enteredSearchText.toLowerCase())));      
      this.dataFoundInGrid.push(this.subjectivityData.filter(x => x.Insured.toLowerCase().includes(data.enteredSearchText.toLowerCase())));            
      this.dataFoundInGrid.push(this.pendingData.filter(x => x.Insured.toLowerCase().includes(data.enteredSearchText.toLowerCase())));
      this.dataFoundInGrid.push(this.boundData.filter(x => x.Insured.toLowerCase().includes(data.enteredSearchText.toLowerCase())));                 
    }
    
    if(data.selectedSearchBy == "PolicyNumber" || data.selectedSearchBy == "SubmissionID"){
      this.dataFoundInGrid.push(this.actionRequiredData.filter(x => x.SubmissionID.toLowerCase() === data.enteredSearchText.toLowerCase()));
      this.dataFoundInGrid.push(this.upcomingData.filter(x => x.SubmissionID.toLowerCase() === data.enteredSearchText.toLowerCase()));      
      this.dataFoundInGrid.push(this.subjectivityData.filter(x => x.SubmissionID.toLowerCase() === data.enteredSearchText.toLowerCase() || x.PolicyNumber.toLowerCase() === data.enteredSearchText.toLowerCase()));            
      this.dataFoundInGrid.push(this.pendingData.filter(x => x.SubmissionID.toLowerCase() === data.enteredSearchText.toLowerCase()));
      this.dataFoundInGrid.push(this.boundData.filter(x => x.SubmissionID.toLowerCase() === data.enteredSearchText.toLowerCase() || x.PolicyNumber.toLowerCase() === data.enteredSearchText.toLowerCase()));      
    }

    if(this.dataFoundInGrid !== undefined && this.dataFoundInGrid.length > 0){
      for(var i=0; i<this.dataFoundInGrid.length; i++){
        this.allDataFoundInGrid = this.allDataFoundInGrid.concat(this.dataFoundInGrid[i]);          
      }
    }
          
    //to remove the duplicate records
    this.dataUniqueFoundInGrid = this.allDataFoundInGrid.reduce((acc, item) => {
      if (!acc.some(obj => obj.SubmissionID === item.SubmissionID)) {
        acc.push(item);
      }
      return acc;
    }, []);

    this.AdvancedSearchData = this.dataUniqueFoundInGrid; 

    if(this.AdvancedSearchData == undefined || !(this.AdvancedSearchData.length > 0)){
      if(data.selectedSearchBy == "InsuredName")
        this.InsuredName = data.enteredSearchText;
      else
        this.InsuredName = "";
      if(data.selectedSearchBy == "PolicyNumber" || data.selectedSearchBy == "SubmissionID")
        this.PolicyIdentifier = data.enteredSearchText;
      else
        this.PolicyIdentifier = "";
      
        this.dashboard.getDashboardAdvancedSearchData(this.selectedSubComp, this.InsuredName, this.PolicyIdentifier).subscribe(
        data => {        
          this.dashboardGridList6 = data;
          this.AdvancedSearchData = this.dashboardGridList6.Policies;  
          this.AdvancedSearchCount = this.AdvancedSearchData.length;
          this.accordionGridData[0].accordion[0].gridDefination.data = this.AdvancedSearchData;
          this.accordionGridData[0].accordion[0].isAdvSearch = true;  
          this.accordionGridData[0].accordion[0].gridDefination.gridOptions.pageLength = 10;
          this.accordionGridData[0].accordion[0].gridDefination.gridOptions.paging = true;
          this.accordionGridData[0].accordion[0].loading = false;
          this.accordionGridData[0].accordion[0].isServiceError = false;        
        },
        error => {  
          this.accordionGridData[0].accordion[0].isServiceError = true;        
          //throw error;
        }
      );
    }
    else
    {      
      this.AdvancedSearchCount = this.AdvancedSearchData.length;
      this.accordionGridData[0].accordion[0].gridDefination.data = this.AdvancedSearchData;
      this.accordionGridData[0].accordion[0].isAdvSearch = true;  
      this.accordionGridData[0].accordion[0].gridDefination.gridOptions.pageLength = 10;
      this.accordionGridData[0].accordion[0].gridDefination.gridOptions.paging = true;
      this.accordionGridData[0].accordion[0].loading = false;
      this.accordionGridData[0].accordion[0].isServiceError = false;
    }
  }

  
  updateAccordianHeader(index: number, status: any) {
    this.accordionGridData[index].accordion[0].subHeading =
      this.dashboardSitecoreData.gridData[index-1].gridName + ' - ' + `${status}`;
  }

  getBaggageData() {
    let upcomingCount = this.badges[0].displayItems.find(
      badge => badge.orderId == '1'
    );
    let actionCount = this.badges[0].displayItems.find(
      badge => badge.orderId == '2'
    );
    let boundCount = this.badges[0].displayItems.find(
      badge => badge.orderId == '3'
    );

    this.badge = new BadgesControl();

    this.cdr.detectChanges();
    this.badge.addTab(this.upcomingDataCount, upcomingCount.keyText, false);
    this.badge.addTab(this.actionRequiredCount, actionCount.keyText, false);
    this.badge.addTab(this.subjectivityCount, boundCount.keyText, false);
    //this.badgeLoading = false;
  }
  badgeSelected(event: any) {
    this.gridDataRefresh();
    if (event > -1) {
      this.accordionGridData.forEach(_accordian => {
        _accordian.accordion[0].isToggle = false;
        _accordian.accordion[0].gridDefination.data = [];
        _accordian.accordion[0].loading = true;
      });
      let expandingIndex = event;
      this.scrollToAccordian();

      switch (event) {
        case 0:
          {
            expandingIndex = 1;
            setTimeout(() => {
              this.accordionGridData[2].accordion[0].gridDefination.data = this.upcomingData;
              this.gridRefresh = true;
            }, 500);
          }
          break;
        case 1:
          {
            expandingIndex = 0;
            setTimeout(() => {
              this.accordionGridData[1].accordion[0].gridDefination.data = this.actionRequiredData;
              this.gridRefresh = true;
            }, 500);
          }
          break;
        case 2:
          {
            expandingIndex = 2;
            setTimeout(() => {
              this.accordionGridData[3].accordion[0].gridDefination.data = this.subjectivityData;
              this.gridRefresh = true;
            }, 500);
          }
          break;
        default:
          break;
      }
      this.accordionGridData[expandingIndex].accordion[0].isToggle = true;
    }
  }
  scrollToAccordian() {
    let scrollElement = this.customElement.nativeElement.querySelector('nav');
    scrollElement.scrollIntoView({ behavior: 'smooth' });
  }

  agencyLossRun() {
    this.loaderService.show();
    let subcompanyList: Array<string> = this.globalVarService.portalAccess.map(
      item => item.SubCompanyCode
    );
    let agencyLossRunRequest: AgencyLossRunRequest = {
      SubCompanyCode: subcompanyList.join(','),
      AgencyContactId: this.globalVarService.agencyId
    };
    this.dashboard
      .agencyLossRun(agencyLossRunRequest)
      .subscribe((agencyLossRun: AgencyLossRunResponse) => {
        if (agencyLossRun.Status === Status.Success) {
          this.documentService.downloadExcelFromBase64(
            agencyLossRun.Base64Result,
            'agency-loss-run'
          );
          this.loaderService.hide();
        } else if (agencyLossRun.Status === Status.Failure) {
          this.alert.error(agencyLossRun.Errors.join(','));
          this.loaderService.hide();
        }
      });
  }

  boundPolicyReport() {
    this.loaderService.show();
    let boundPolicyReportRequest: BoundPolicyReportRequest = {
      AgencyContactId: this.globalVarService.agencyId,
      SortColumn: 'PolicyEffectiveDate',
      SortOrder: 'DESC'
    };
    this.dashboard
      .boundPolicyReport(boundPolicyReportRequest)
      .subscribe((boundPolicyReport: BoundPolicyReportResponse) => {
        this.documentService.exportAsExcelFile(
          boundPolicyReport.CasualtyBoundPolicies,
          'bound-policy-report'
        );
        this.loaderService.hide();
      });
  }
}
